"use strict";

exports.__esModule = true;
exports.default = "\n  varying vec2 vUv;\n  void main() {\n    vUv = uv;\n    gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n  }\n";
module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-distortion-image/lib/vertex.js
 ** module id = 448
 ** module chunks = 0
 **/